module.exports = __webpack_public_path__ + "img/选型_u13.468692d3.svg";